import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

import { ActionMenuItem, IActionMenuOption } from "@livechat/design-system-react-components";

import { EventPlace, trackEngagement } from "helpers/analytics";
import { LicenseActions } from "store/entities/license";

import { FormContextMenu } from "../components/FormContextMenu";
import { SettingsRoutes } from "../constants";

type Props = {
  id: string;
  disabled: boolean;
  disabledDuplicate: boolean;
  isDefault: boolean;
  onDelete: (id: string) => void;
  initialTemplate: boolean;
  isCreatedUsingVisualBuilder: boolean;
};

export type IItem = {
  itemId: string;
  content: React.ReactNode;
  onItemSelect(): void;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function TemplateListContextMenu({
  id,
  disabled,
  isDefault,
  onDelete,
  disabledDuplicate,
  initialTemplate,
}: Props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const options: IActionMenuOption[] = [
    {
      key: "edit",

      element: <ActionMenuItem>Edit</ActionMenuItem>,
      onClick: () => history.push(`${SettingsRoutes.EmailTemplates}/edit/${id}`),
    },
    {
      key: "duplicate",
      disabled: disabledDuplicate,
      element: <ActionMenuItem>Duplicate</ActionMenuItem>,
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      onClick: () => {
        trackEngagement("Email templates: Duplicate template", EventPlace.Settings, { id, initialTemplate });
        history.push(`${SettingsRoutes.EmailTemplates}/duplicate/${id}`);
      },
    },
    {
      key: "default",
      disabled: isDefault,
      element: <ActionMenuItem>Set as default</ActionMenuItem>,
      onClick: () => dispatch(LicenseActions.updateDefaultTemplate({ defaultTemplateId: id })),
    },
    {
      key: "delete",
      disabled: isDefault,
      element: <ActionMenuItem kind="warning">Delete</ActionMenuItem>,
      onClick: () => onDelete(id),
    },
  ];

  return <FormContextMenu disabled={disabled} options={options} id={id} />;
}
